<app-image
	[size]="imageSize"
	[src]="organization[theme].wordmarkURL"
></app-image>
